<script setup>
import { inject, provide } from 'vue';
import ClickableHeader from '@/components/Shared/ClickableHeader.vue';

const trans = inject('trans');

const props = defineProps({
  manual: {
    type: Object,
    required: true,
  },
});

provide('title', trans('common.manual') + ' ' + props.manual.application.name);
</script>

<script>
import ManualsLayout from '@/Layouts/ManualsLayout.vue';

export default {
  layout: ManualsLayout,
};
</script>

<template>
  <div class="manual-profile-wrapper">
    <div class="manual-profile-content">
      <div class="flex-row my-5">
        <h2>
          {{ trans('common.manual') }} <span class="">{{ manual.application.name }}</span>
        </h2>
      </div>
      <div class="flex-row my-5">
        <clickable-header :header="trans('common.prerequisite')" />
        <div v-html="manual.prerequisite"></div>
      </div>
      <div class="flex-row my-5">
        <clickable-header :header="trans('common.authentication')" />
        <div v-html="manual.authentication"></div>
      </div>

      <div class="flex-row my-5">
        <h2 id="flows">{{ trans('common.flows') }}</h2>
      </div>

      <div v-for="flowManual in manual.flowManuals" :key="`flow-manuals-${flowManual.id}`" class="flex-row my-5">
        <clickable-header :header="flowManual.flow" />
        <div v-html="flowManual.content"></div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.manual-profile {
  &-content {
    width: 90%;
    margin: 0 auto;

    & h2 {
      font-size: 26px;
      font-weight: bold;
      line-height: 32px;
      font-style: normal;
      text-align: left;
      color: #5c5d5d;

      & > span {
        color: #2fabec;
      }
    }
  }

  &-wrapper {
    background: white;
  }

  &-logo {
    display: flex;
    justify-content: center;
    align-items: center;

    & img {
      width: 100%;
      border-radius: 10px;
      filter: drop-shadow(0px 2px 2.5px rgba(0, 122, 255, 0.09));
    }
  }
}

.back {
  &-wrapper {
    display: flex;
    justify-content: flex-start;
    gap: 20px;
  }

  &-link {
    font-size: 16px;
    font-weight: bold;
    line-height: 24px;
    font-style: normal;
    text-align: left;
    color: #9a9a9a;

    &:hover {
      color: #5c5d5d !important;
      text-decoration: none;
    }
  }
}

.profile-info {
  margin-top: 30px;
  margin-bottom: 30px;

  & p {
    font-size: 16px;
    line-height: 20px;
    color: #3f3f3f;
    font-style: normal;
    font-weight: 300;

    &:nth-child(1) {
      font-weight: bold;
      font-size: 18px;
      line-height: 40px;
      color: #5c5d5d;
      font-style: normal;
    }
  }

  &-header {
    & > p {
      font-size: 20px;
      font-weight: bold;
      line-height: 24px;
      color: #3f3f3f;
    }
  }
}
</style>
